let lasClick = 0;

export const clickUpload = (id: string) => {
  const now = new Date().getTime();
  if (now - lasClick < 600) {
    return;
  }
  lasClick = now;
  const el = document.getElementById(id);
  if (el) {
    el.click();
  } else {
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.click();
      }
    }, 100);
  }
};
